import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase';

const YesterdayLeaderboard = ({ quizDate }) => {
  const [yesterdayLeaderboard, setYesterdayLeaderboard] = useState([]);

  const fetchYesterdayLeaderboardData = async () => {
    try {
      const yesterdayDate = new Date(new Date(quizDate).getTime() - 86400000);
      const q = query(
        collection(db, 'performances'),
        where('date', '>=', yesterdayDate.toISOString().slice(0, 10) + 'T00:00:00.000Z'),
        where('date', '<', yesterdayDate.toISOString().slice(0, 10) + 'T23:59:59.999Z'),
        orderBy('points', 'desc'),
        limit(10)
      );

      const querySnapshot = await getDocs(q);
      const leaderboardData = await Promise.all(
        querySnapshot.docs.map(async (doc) => {
          const performanceData = doc.data();
          const playerQuery = query(collection(db, 'players'), where('id', '==', performanceData.playerId));
          const playerSnapshot = await getDocs(playerQuery);
          if (!playerSnapshot.empty) {
            const playerInfo = playerSnapshot.docs[0].data();
            return {
              ...performanceData,
              playerName: playerInfo.name,
              avatar: playerInfo.avatar,
              gender: playerInfo.gender,
            };
          } else {
            console.error(`Player document not found for playerId: ${performanceData.playerId}`);
            return {
              ...performanceData,
              playerName: 'Unknown',
              avatar: 'unknown',
            };
          }
        })
      );

        // Filter out players with zero points
      const filteredLeaderboard = leaderboardData.filter(player => player.points > 0);
 
      setYesterdayLeaderboard(filteredLeaderboard);
    } catch (error) {
      console.error('Error fetching yesterday leaderboard data:', error);
    }
  };

  useEffect(() => {
    fetchYesterdayLeaderboardData();
  }, [quizDate]);

  if (yesterdayLeaderboard.length < 3) {
    return null; // Don't render the leaderboard if there are fewer than 3 players
  }

  return (
    <div className="leaderboard-container">
      <div className="leaderboard-header">
        <h5 className='winertextTitle'>The Winners' Circle <br/><span>Yesterday's Edition</span> </h5>
      </div>
      <div className="leaderboard-podium">
        <div className="podium-player">
          <div className="player-avatar">
            <img src={yesterdayLeaderboard[1].avatar} alt="Player Avatar" />
          </div>
          <span className='player-name-lb'>{yesterdayLeaderboard[1].playerName}</span>
          <div className="player-rank">2</div>
        </div>
        <div className="podium-player">
          <div className="player-avatar winner-avatar">
            <img src={yesterdayLeaderboard[0].avatar} alt="Player Avatar" />
          </div>
          <span className='player-name-lb'>{yesterdayLeaderboard[0].playerName}</span>
          <img className='winner-ribbon' src='/quiz-zone/image/ribbon.png' alt='winner' />
          <div className="player-rank">1</div>
        </div>
        <div className="podium-player">
          <div className="player-avatar">
            {yesterdayLeaderboard.length > 2 ? (
              <img src={yesterdayLeaderboard[2].avatar} alt="Player Avatar" />
            ) : (
              <img src="/quiz-zone/image/default-profile-male.png" alt="Player Avatar" />
            )}
            <span className='player-name-lb'>{yesterdayLeaderboard[2].playerName}</span>
          </div>
          <div className="player-rank">3</div>
        </div>
      </div>
      <div className='lb-list'>
        <div className="leaderboard-list">
          {yesterdayLeaderboard.slice(3, 10).map((player, index) => (
            <div
              key={player.playerId}
              className={"leaderboard-item"}
            >
              <span className="rank">{index + 4}</span>
              <img
                src={player.avatar}
                alt="Player"
                className="player-image"
              />
              <div className="player-info">
                <span className="player-name">{player.playerName}</span>
              </div>
              <span className="player-points">{player.points}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default YesterdayLeaderboard;
